export default "__VITE_ASSET__OPmlWeJq__"